import React from 'react';
import styled from 'styled-components/native';
import {useTheme} from 'styled-components';
import {Theme} from '../../theme/lightTheme';
import TextGeneric from '../textGeneric';
import {LinearGradient} from 'react-native-linear-gradient';
import ProgressiveImage from '../progressiveImage';
import {DrugItemProps} from '../../interfaces/components/drugItem';

const Container = styled.TouchableOpacity<any>`
  width: 100%;
  background-color: ${({theme}) => theme.text.light};
  shadow-color: ${({theme}) => theme.text.dark};
  shadow-offset: 2px 4px;
  shadow-opacity: 0.4;
  shadow-radius: 5px;
  elevation: 5;
  border-radius: ${({borderRadius}) => borderRadius}px;
  ${({isDynamicRatio}) => !isDynamicRatio && 'aspect-ratio: 1'};
  border-width: 2px;
  border-color: ${({theme}) => theme.text.light};
`;
const ImageContainer = styled.View<any>`
  width: 100%;
  height: 100%;
  border-radius: ${({borderRadius}) => borderRadius}px;
  z-index: 1;
  position: absolute;
  top: 0;
  overflow: hidden;
`;
const Image = styled(ProgressiveImage)`
  width: 100%;
  height: 100%;
`;
const ContentContainer = styled.View`
  z-index: 2;
  margin-top: auto;
`;
const Label = styled(TextGeneric)`
  font-size: ${({theme}) => theme.text.s8}px;
  color: ${({theme}) => theme.text.light};
  padding: ${({isDynamicRatio}) => (isDynamicRatio ? '3%' : '5%')};
  text-align: center;
  z-index: 99;
`;

/**
 * Drug Item component.
 *
 * @param {DrugItemProps} props - The Drug Item component props.
 * @returns {React.ReactElement} The rendered Drug Item component.
 */
const DrugItem: React.FC<DrugItemProps> = ({
  style,
  onPress,
  name,
  imageUri,
  defaultImage,
  isDynamicRatio,
  borderRadius = 10,
}: DrugItemProps): React.ReactElement => {
  const theme = useTheme() as Theme;

  const _renderBackground = () => {
    return (
      <ImageContainer borderRadius={borderRadius}>
        <LinearGradient
          style={{
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'flex-end',
            zIndex: 1,
            position: 'absolute',
            top: 0,
          }}
          colors={[
            isDynamicRatio ? theme.secondary + '99' : 'transparent',
            isDynamicRatio ? theme.secondary + '99' : 'rgba(0,0,0,0.9)',
          ]}
        />
        <Image
          resizeMode={'cover'}
          defaultImage={
            defaultImage
              ? defaultImage
              : require('../../assets/images/drugPlaceholder.png')
          }
          source={{uri: imageUri}}
        />
      </ImageContainer>
    );
  };
  return (
    <Container
      borderRadius={borderRadius}
      disabled={!onPress}
      style={style}
      isDynamicRatio={isDynamicRatio}
      onPress={onPress}>
      {!isDynamicRatio && _renderBackground()}
      <ContentContainer>
        {isDynamicRatio && _renderBackground()}
        <Label isDynamicRatio={isDynamicRatio} semiBold>
          {name || ''}
        </Label>
      </ContentContainer>
    </Container>
  );
};

export default DrugItem;
